import React from "react";
import { Box, Card, CardContent, Container, Grid, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";

const StyledCard = styled(Card)(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
    "&:hover": {
        transform: "translateY(-8px)",
        boxShadow: '0 4px 12px 0 rgba(0,0,0,0.2)'
    },
    background: "linear-gradient(145deg, #f4f4f6 0%, #ffffff 100%)",
    boxShadow: '0 4px 12px 0 `rgba(0,0,0,0.1)`'
}));

const SupportOverview = () => {
    const supportFeatures = [
        {
            title: "Fast Support Turnaround",
            description: "We respond to your queries within 24 hours, so you can get back to work quickly",
            ariaLabel: "Support response time information"
        },
        {
            title: "Comprehensive Documentation",
            description: "As you build your workflows, we'll produce custom documentation to help you along the way",
            ariaLabel: "Documentation information"
        },
        {
            title: "Seamless Onboarding",
            description: "From the moment you sign up, we'll guide you through the process of setting up your account",
            ariaLabel: "Onboarding information"
        }
    ];

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 4, md: 8 },
            }}
        >
            <Container>
                <Grid container spacing={4}>
                    {supportFeatures.map((feature, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <StyledCard
                                elevation={3}
                                aria-label={feature.ariaLabel}
                            >
                                <CardContent sx={{ textAlign: "center", p: 4 }}>
                                    <Typography
                                        fontFamily="Red Rose"
                                        fontSize="24px"
                                        component="h3"
                                        color="#1e1559"
                                        gutterBottom
                                        sx={{ 
                                            fontWeight: 600,
                                            lineHeight: 1.1,
                                            '@media (max-width: 600px)': {
                                                fontSize: '20px',
                                            },
                                        }}
                                    >
                                        {feature.title}
                                    </Typography>
                                    <Typography
                                        fontFamily="Raleway"
                                        fontSize="18px"
                                        color="text.secondary"
                                        sx={{ 
                                            lineHeight: 1.7,
                                            '@media (max-width: 600px)': {
                                                fontSize: '16px',
                                            },
                                        }}
                                    >
                                        {feature.description}
                                    </Typography>
                                </CardContent>
                            </StyledCard>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default SupportOverview;